import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { find, get } from 'lodash';
import Title from '../title';
import MemberCard from './member-card';

class InviteesShareBreakdown extends Component {
  showingInviteesBreakdown() {
    return this.props.memberships.length > 0;
  }

  renderInviteesCards() {
    const { memberships } = this.props;
    const cards = memberships.map(membership => (
      <div className="col-12" key={`member-card-${membership.id}`}>
        {this.renderMemberCard(membership)}
      </div>
    ));
    return <div className="row">{cards}</div>;
  }

  renderMemberCard(membership) {
    const projected = find(this.props.projectedMemberships, (m) => m.id === membership.id);
    return (
      <MemberCard
        onRemoveMember={this.props.onRemoveMember}
        membership={membership}
        totalAmount={get(projected, 'amount')}
        refundableAmount={get(projected, 'refundableAmount')}
        consumerFee={get(projected, 'fees.consumerFee')}
        viewAs="organizer"
      />
    );
  }

  render() {
    if (!this.showingInviteesBreakdown()) return null;
    return (
      <div className="invitees-share-breakdown">
        <Title
          text={
            <FormattedMessage
              id="inviteesShareBreakdown.title"
              defaultMessage="Rest of group's payments"
            />
          }
          className="mb-4"
          divider bigger
        />
        {this.renderInviteesCards()}
      </div>
    );
  }
}

InviteesShareBreakdown.defaultProps = {
  user: null,
  purchase: null,
  memberships: [],
  projectedMemberships: [],
  organizerMembership: null,
  onRemoveMember: () => {},
};

export default InviteesShareBreakdown;



// WEBPACK FOOTER //
// ./src/desktop/components/make-purchase/invitees-share-breakdown.js